import React from "react";
import DotsComponent from "../../DotsComponent";
import FinanceDonutChart from "./FinanceRatioChart";

const RatioCard = (props) => {
  return (
    <div className="current">
      <DotsComponent />
      <h3>{props.data.dataheading}</h3>
      <div className="card_details" id="finance-donut-chart">
        <div className="donut-chart">
          <FinanceDonutChart color={props.data.color} />
          <div className="donut-chart-in-data">
            <h4>{props.data.circledatadn}</h4>
            <p>{props.data.circledataup}</p>
          </div>
        </div>
        <div className="finance-donut-right">
          <h5>{props.data.firstpara}</h5>
          <p>{props.data.secondpara}</p>
        </div>
      </div>
    </div>
  );
};

export default RatioCard;
